export default __webpack_public_path__ + "static/1076-1afa8013a2185d4c40504f0a351a0703.gif";